"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imagesDifference = void 0;

var _RgbaImageBuffer = _interopRequireDefault(require("../RgbaImageBuffer"));

var _exceptions = require("../exceptions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Calculates the difference (absolute value) between two images
 *
 * @param {RgbaImageBuffer} firstImgBuffer First image
 * @param {RgbaImageBuffer} secondImgBuffer Second image
 * @returns {RgbaImageBuffer} Result image
 */


var imagesDifference = function imagesDifference(firstImgBuffer, secondImgBuffer) {
  if (firstImgBuffer.height !== secondImgBuffer.height || firstImgBuffer.width !== secondImgBuffer.width) throw new _exceptions.ImageOperationException("ImagesDifferenceException", "Images should have the same width and height");
  var result = firstImgBuffer.copy();

  for (var i = 0; i < result.pixels.length; i += _RgbaImageBuffer.default.NUM_CHANNELS) {
    result.pixels[i] = Math.abs(result.pixels[i] - secondImgBuffer.pixels[i]);
    result.pixels[i + 1] = Math.abs(result.pixels[i + 1] - secondImgBuffer.pixels[i + 1]);
    result.pixels[i + 2] = Math.abs(result.pixels[i + 2] - secondImgBuffer.pixels[i + 2]);
  }

  return result;
};

exports.imagesDifference = imagesDifference;